import { Flex } from "@chakra-ui/react";
import type { HowItWorksCardProps } from "../HowItWorks.types";
import { HowItWorks5StepsDetailedCard } from "./HowItWorks5StepsDetailedCard";

export const HowItWorks5StepsDetailed = ({ cards }: { cards: HowItWorksCardProps[] }) => (
  <Flex direction="column" mb={4}>
    {cards.map((card) => (
      <HowItWorks5StepsDetailedCard {...card} key={card.title} />
    ))}
  </Flex>
);
